import { matchPath } from "react-router-dom";
import { FK } from "../capabilities/featureKeys";
import { WORKSPACE_PERMS } from "../capabilities/workspacePerms";

// Only registered pages that can occur as ancestors. URL groups are deliberately
// absent. Keep these requirements aligned with the corresponding App routes.
export const BREADCRUMB_DESTINATIONS = [
  { path: "/app/welcomepage" },
  { path: "/app/dashboard" },
  { path: "/app/dashboard/lead-command-centre", codes: [FK.DASHBOARD_LEAD_COMMAND_CENTRE_VIEW] },
  { path: "/app/crm", codes: WORKSPACE_PERMS.crm },
  { path: "/app/crm/contacts", codes: [FK.CRM_CONTACT_VIEW] },
  { path: "/app/crm/contacts/:id", codes: [FK.CRM_CONTACT_DETAIL_VIEW] },
  { path: "/app/campaigns", codes: WORKSPACE_PERMS.campaigns },
  { path: "/app/campaigns/image-campaigns/:id", codes: [FK.CAMPAIGN_IMAGE_DETAIL_VIEW] },
  { path: "/app/campaigns/template-campaign-builder", codes: [FK.CAMPAIGN_BUILDER] },
  { path: "/app/inbox", codes: WORKSPACE_PERMS.inbox },
  { path: "/app/scheduling", codes: [FK.SCHEDULING_VIEW] },
  { path: "/app/automation", codes: WORKSPACE_PERMS.automation },
  { path: "/app/ai-agent", codes: WORKSPACE_PERMS.aiAgent },
  { path: "/app/ai-agent/lead-qualification", codes: [FK.AI_AUTO_REPLY_MANAGE] },
  { path: "/app/automation/ai-agent/lead-qualification", codes: [FK.AI_AUTO_REPLY_MANAGE] },
  // The template layout's index redirects to Library, whose guard must pass.
  { path: "/app/template-builder", codes: [FK.TEMPLATE_BUILDER_LIBRARY_BROWSE] },
  { path: "/app/template-builder/drafts", codes: [FK.TEMPLATE_BUILDER_CREATE_DRAFT, FK.TEMPLATE_BUILDER_DRAFT_EDITOR_VIEW] },
  { path: "/app/settings", codes: WORKSPACE_PERMS.settings },
  { path: "/app/settings/scheduling", codes: [FK.SCHEDULING_VIEW] },
  { path: "/app/admin", codes: WORKSPACE_PERMS.superadmin, admin: true },
  { path: "/app/admin/account-insights", codes: [FK.SUPER_ADMIN_SIGNUP_REPORT_VIEW], admin: true },
  { path: "/app/admin/account-insights/account-reports", codes: [FK.SUPER_ADMIN_BUSINESS_OVERVIEW], admin: true },
];

export function canAccessBreadcrumb(path, auth = {}) {
  if (auth.isLoading || ["profilepending", "suspended", "blocked"].includes(String(auth.status || "").toLowerCase())) return false;
  const destination = BREADCRUMB_DESTINATIONS.find(item => matchPath({ path: item.path, end: true }, path));
  if (!destination) return false;
  if (destination.path === "/app/campaigns/image-campaigns/:id" &&
      ["assign-contacts", "assigned-contacts"].includes(path.split("/").pop())) return false;
  const adminish = ["superadmin", "admin", "partner", "reseller"].includes(String(auth.role || "").toLowerCase()) ||
    ["platform.super_admin", "platform.partner", "platform.reseller"].includes(String(auth.roleKey || "").toLowerCase());
  if (destination.admin && !auth.hasAllAccess && !adminish) return false;
  return !destination.codes || auth.hasAllAccess || destination.codes.some(code => auth.can?.(code));
}
